import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const myMenuSurveyRequest = (token, startDate, endDate, selectedRestaurant) => {
  const organizationId = localStorage.getItem("organizationId");

  const url =
    apiURl +
    "Survey/GetSurveysByDate?startDate=" +
    startDate +
    "&endDate=" +
    endDate +
    "&organizationId=" +
    organizationId +
    "&restaurantId=" +
    selectedRestaurant;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export { myMenuSurveyRequest };
